import React, {useEffect, useState, useRef, forwardRef, useImperativeHandle} from 'react';
import {Checkbox, Modal, Toast, Switch, Icon, Button} from 'antd-mobile-v2';
import Dayjs from 'dayjs';
import queryString from 'query-string';
import BackHeader from '@comp/BackHeader/index';
import {editPatient, fetchPatientDetail, fetchImgCode, fetchSmsCode} from '@/store/api/user';
import {getUser, storage} from '@/utils/tools';
import {Identification, getBirthFromIDCard, getSexFromIDCard, isMobilePhone, getAgeFromBirth} from '@/utils/verify';

import './index.less';

export default function (props) {
  const cp = storage.get('GU_INFO');
  const {user_id, record_id} = queryString.parse(props.location.search);
  const smsRef = useRef(null);
  const [form, setForm] = useState({
    family_name: '',
    family_birth: '',
    family_age: '',
    family_phone: '',
    family_sex: '1',
    has_medicare_card: '0',
    family_default: '0',
    id_card: '',
    security_code: '',
    guardian_uid: cp ? cp.patient_uid : '',
    user_id,
  });
  const [isCard, setIsCard] = useState(false);
  const [realCard, setRealCard] = useState(false);

  useEffect(async () => {
    let res = await fetchPatientDetail({
      record_id,
      user_id,
    });

    setForm({...form, ...res});
    setIsCard(!!res.id_card);

    return () => {
      storage.remove('GU_INFO');
    };
  }, []);

  const onSubmit = () => {
    if (!isCard && form.id_card && !realCard) {
      Toast.fail('请填写正确的身份证号码');
      return;
    }
    if (!Number.isInteger(Number(form.family_age)) || form.family_age < 1 || form.family_age > 120) {
      Toast.fail('请填写正确的年龄');
      return;
    }
    if (form.check_smscode_flag == 1) {
      smsRef.current.showModal();
    }
    if (form.check_smscode_flag == 2) {
      onEdit();
    }
  };

  const onChangeForm = (key, val) => {
    if (key === 'id_card') {
      handleIdCard(val);
    } else {
      form[key] = val;
      setForm({...form});
    }
  };

  const handleIdCard = card => {
    console.log(card);
    const flag = Identification.isID(card).result;
    setRealCard(flag);
    if (flag) {
      const birth = getBirthFromIDCard(card);
      const sex = getSexFromIDCard(card);
      const age = getAgeFromBirth(birth);
      form.family_birth = birth;
      form.family_age = age;
      form.family_sex = sex;
      form.id_card = card;
    } else {
      form.id_card = card;
    }
    setForm({...form});
  };

  const validateBirth = () => {
    if (isCard) return true;
    return !!form.family_birth;
  };

  const onEdit = async sms => {
    form.security_code = sms;
    const {patient_name, patient_phone, patient_uid} = cp || {};
    const para = {
      family_age: `${form.family_age}`,
      family_birth: Dayjs().subtract(form.family_age, 'year').format('YYYY-MM-DD'),
      family_default: `${form.family_default}`,
      is_default: `${form.family_default}`,
      family_indentity_num: `${form.family_indentity_num}`,
      family_indentity_type: `${form.family_indentity_type}`,
      family_sex: `${form.family_sex}`,
      has_medicare_card: `${form.has_medicare_card}`,
      tokenid: '',
      guardian_name: patient_name,
      guardian_phone: patient_phone,
      guardian_uid: patient_uid,
    };
    delete form.status;
    delete form.original;
    delete form.isOK;
    delete form.message;
    // 不发验证码
    if (form.check_smscode_flag == 2) delete form.security_code;
    setForm({...form});
    const {status, message} = await editPatient({...form, ...para, security_code: sms});
    if (status == '0') {
      Toast.success('编辑成功', 2, () => {
        storage.remove('GU_INFO');
        history.back();
      });
    } else {
      Toast.fail(message);
    }
  };

  const renderGName = () => {
    if (cp) return cp.patient_name;
    if (form.guardian_name) return form.guardian_name;

    return '未选择';
  };

  const onBeforeBack = () => {
    storage.remove('GU_INFO');
  };

  return (
    <section className="page">
      <BackHeader title="编辑就诊人" onBeforeBack={() => onBeforeBack()} />
      <article className="main patient-add">
        <div className="form">
          <div className="form-item">
            <label>
              <i className="required">*</i>姓名
            </label>
            <input type="text" placeholder="请输入真实姓名" maxLength={10} disabled={true} value={form.family_name} />
          </div>
          <div className="form-item">
            <label>身份证号</label>
            <input
              type="text"
              placeholder="请输入身份证号码"
              value={form.id_card}
              disabled={isCard}
              onChange={e => onChangeForm('id_card', e.target.value)}
            />
          </div>
          <div className="form-item">
            <label>
              <i className="required">*</i>性别
            </label>
            <div className="checkbox-group">
              <Checkbox
                disabled={isCard || realCard}
                checked={form.family_sex == '1'}
                onChange={() => onChangeForm('family_sex', '1')}
              >
                <span className="label">男</span>
              </Checkbox>
              <Checkbox
                disabled={isCard || realCard}
                checked={form.family_sex == '2'}
                onChange={() => onChangeForm('family_sex', '2')}
              >
                <span className="label">女</span>
              </Checkbox>
            </div>
          </div>
          <div className="form-item birth">
            {/*<DatePicker*/}
            {/*  mode="date"*/}
            {/*  extra="请选择日期"*/}
            {/*  minDate={new Date('1900-01-01')}*/}
            {/*  maxDate={new Date()}*/}
            {/*  disabled={isCard || realCard}*/}
            {/*  value={new Date(form.family_birth)}*/}
            {/*  onChange={date => onChangeForm('family_birth', date)}*/}
            {/*>*/}
            {/*  <List.Item>*/}
            {/*    <i className="required">*</i>生日*/}
            {/*  </List.Item>*/}
            {/*</DatePicker>*/}
            <label>
              <i className="required">*</i>年龄
            </label>
            <input
              type="text"
              placeholder="请输入年龄"
              disabled={isCard || realCard}
              value={form.family_age}
              onChange={e => onChangeForm('family_age', e.target.value)}
            />
          </div>
          <div className="form-item">
            <label>
              <i className="required">*</i>手机号
            </label>
            <input type="text" placeholder="请输入手机号" maxLength={11} disabled={true} value={form.family_phone} />
          </div>
          <div className="form-item">
            <div className="lft">是否有医保卡</div>
            <Switch
              checked={form.has_medicare_card == '1'}
              onChange={checked => onChangeForm('has_medicare_card', `${Number(checked)}`)}
            />
          </div>
          <div className="form-item">
            <div className="lft">
              <span>设为默认就诊人</span>
              <span className="tip">注：每次下单时会使用该就诊人</span>
            </div>
            <Switch
              checked={form.family_default == '1'}
              onChange={checked => onChangeForm('family_default', `${Number(checked)}`)}
            />
          </div>
          {form.family_age <= 6 ? (
            <div className="form-item" onClick={() => props.history.push('/patient/list/selectguardian')}>
              <div className="lft">
                <span>监护人</span>
                <span className="tip">注：6岁以下儿童须关联就诊人</span>
              </div>
              <div className="link">
                <span>{renderGName()}</span>
                <Icon type="right" />
              </div>
            </div>
          ) : (
            ''
          )}
          <input type="submit" className="btn-next" value="保存" onClick={onSubmit} />
        </div>
      </article>
      <SmsModal ref={smsRef} user_id={user_id} mobile_number={form.family_phone} onGetData={onEdit} />
    </section>
  );
}

const SMSModal = function (props, ref) {
  const {user_id, mobile_number} = props;
  const [visible, setVisible] = useState(false);
  const [count, setCount] = useState(60);
  const [imgCode, setImgCode] = useState({});
  const [smsFlag, setSmsFlag] = useState(false);
  const [smsForm, setSmsForm] = useState({
    mobile_number: '',
    os_type: '',
    piccode_key: '',
    piccode_res: '',
    push_type: '4',
    security_type: '5',
    token: '',
  });
  const [smsCode, setSmsCode] = useState('');

  useImperativeHandle(ref, () => ({
    showModal: () => {
      setVisible(true);
    },
  }));

  useEffect(() => {
    if (visible) getImgCode();
  }, [visible]);

  useEffect(() => {
    setSmsForm({...smsForm, mobile_number});
  }, [props.mobile_number]);

  const getImgCode = async () => {
    const {data, status, message} = await fetchImgCode({user_id});
    if (status === 0) {
      setImgCode(data);
    } else {
      Toast.fail(message);
    }
  };

  const onIptImgCode = val => {
    const flag = val.length === 4;
    setSmsFlag(flag);
    if (flag) {
      smsForm.piccode_res = val;
      setSmsForm({...smsForm});
    }
  };

  const onIptSmsCode = val => {
    if (!val) return;
    setSmsCode(val);
  };

  function countTime(cb) {
    let num = 60;

    let timer = setInterval(() => {
      num -= 1;
      if (num === 0) clearInterval(timer);
      if (cb) cb(num);
    }, 1000);
  }

  const onGetSms = async () => {
    if (!smsFlag) return;
    const {status, message} = await fetchSmsCode(smsForm);
    if (status === '0') {
      Toast.success('短信发送成功');
      countTime(num => {
        setCount(num);
      });
    } else {
      Toast.fail(message);
    }
  };

  const onCancel = () => {
    setVisible(false);
  };

  const onOk = () => {
    if (!smsForm.piccode_res) {
      Toast.fail('请填写图片验证码');
      return;
    }
    if (!smsCode) {
      Toast.fail('请填写短信验证码');
      return;
    }

    setVisible(false);
    props.onGetData(smsCode);
  };

  const renderBtn = () => {
    let ht = '';
    if (count === 60) {
      ht = (
        <Button disabled={!smsFlag} type="warning" onClick={onGetSms}>
          获取短信
        </Button>
      );
    } else if (count === 0) {
      ht = (
        <Button
          disabled={!smsFlag}
          type="warning"
          onClick={() => {
            setCount(59);
            onGetSms();
          }}
        >
          重新获取短信
        </Button>
      );
    } else {
      ht = (
        <Button disabled={true} type="warning">
          {`${count}s`}
        </Button>
      );
    }

    return ht;
  };

  return (
    <Modal
      className="sms-modal"
      popup
      visible={visible}
      title="验证"
      footer={[
        {text: '取消', onPress: () => onCancel()},
        {text: '确定', onPress: () => onOk()},
      ]}
    >
      <div className="img-code">
        <input type="text" maxLength={4} onInput={e => onIptImgCode(e.target.value)} />
        <img onClick={getImgCode} src={imgCode.code_url} alt="验证码" />
      </div>
      <div className="sms-code">
        <input type="text" maxLength={6} onChange={e => onIptSmsCode(e.target.value)} />
        {renderBtn()}
      </div>
    </Modal>
  );
};

const SmsModal = forwardRef(SMSModal);
